export default __webpack_public_path__ + "static/media/img-600x400-1.132cc97e.jpg";